import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import MoneyIcon from '@material-ui/icons/AttachMoney';
import { azureCostsApi } from './api';
import { rootRouteRef } from './routes';

/** "Azure costs" — in the sidebar. The backend serves the admins only. */
export const costsPage = PageBlueprint.make({
  params: {
    path: '/azure-costs',
    title: 'Azure costs',
    icon: <MoneyIcon />,
    routeRef: rootRouteRef,
    loader: () => import('./components/CostsPage').then(m => <m.CostsPage />),
  },
});

/**
 * "Azure cost" card on System and Component pages, and on Azure resource
 * groups and imported Azure resources. The backend serves admins only; for
 * anyone else the card renders nothing.
 */
export const entityCostCard = EntityCardBlueprint.make({
  name: 'entity-cost',
  params: {
    type: 'info',
    filter: entity => {
      const kind = entity.kind.toLocaleLowerCase('en-US');
      return (
        kind === 'system' ||
        kind === 'component' ||
        (kind === 'resource' &&
          (entity.spec?.type === 'azure-resource-group' ||
            Boolean(entity.metadata.annotations?.['limex.pro/resource-id'])))
      );
    },
    loader: () =>
      import('./components/EntityCostCard').then(m => <m.EntityCostCard />),
  },
});

export const azureCostsPlugin = createFrontendPlugin({
  pluginId: 'azure-costs',
  extensions: [azureCostsApi, costsPage, entityCostCard],
  routes: {
    root: rootRouteRef,
  },
});
